/**
 * Currency configuration
 */
export const CURRENCIES = [
  { code: 'CLP', label: 'CLP — Peso chileno', symbol: '$', locale: 'es-CL', decimals: 0 },
  { code: 'USD', label: 'USD — US Dollar', symbol: '$', locale: 'en-US', decimals: 2 },
  { code: 'EUR', label: 'EUR — Euro', symbol: '€', locale: 'de-DE', decimals: 2 },
  { code: 'MXN', label: 'MXN — Peso mexicano', symbol: '$', locale: 'es-MX', decimals: 2 },
];

/**
 * Format a number as currency
 */
export function formatCurrency(amount, currency = 'USD') {
  const config = CURRENCIES.find((c) => c.code === currency);
  const locale = config?.locale || 'en-US';
  const decimals = config?.decimals ?? 2;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
}

/**
 * Format a date string to locale format
 */
export function formatDate(dateStr, locale = 'es') {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString(locale === 'es' ? 'es-ES' : 'en-US', {
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Calculate percentage with bounds
 */
export function percentage(value, total) {
  if (total === 0) return 0;
  return Math.min(Math.round((value / total) * 100), 100);
}

/**
 * Generate a unique ID
 */
export function uid() {
  return crypto.randomUUID();
}

/**
 * Category colors mapping
 */
export const CATEGORY_COLORS = {
  food: '#f59e0b',
  transport: '#3b82f6',
  housing: '#8b5cf6',
  entertainment: '#ec4899',
  health: '#10b981',
  education: '#06b6d4',
  shopping: '#f97316',
  services: '#6366f1',
  salary: '#22c55e',
  freelance: '#14b8a6',
  service: '#0ea5e9',
  credit: '#7c3aed',
  unit_cost: '#f43f5e',
  other: '#94a3b8',
};

/**
 * Category icons mapping
 */
export const CATEGORY_ICONS = {
  food: '🍽️',
  transport: '🚗',
  housing: '🏠',
  entertainment: '🎬',
  health: '💊',
  education: '📚',
  shopping: '🛍️',
  services: '⚡',
  salary: '💰',
  freelance: '💼',
  service: '🤝',
  credit: '💳',
  unit_cost: '🏷️',
  other: '📌',
};
